import FaqSection from '@/v2/components/sections/common/faq-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  faqSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionContent,
  typesOfGolfClubsSectionContent,
  whyChooseUsSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/golf-club-storage-page'

interface GolfClubStoragePageProps {}

const GolfClubStoragePage: React.FC<GolfClubStoragePageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName='w-[324px] h-[218px] md-mn:w-[380px] md-mn:h-[286px] lg:!w-[448px] lg:!h-[313px] xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[285px] xl-min:!h-[50px] w-[266px] h-[44px]'
      />
      <WhyWeSection
        isBgDark
        {...whyWeSectionContent}
        className='md-mn:[&_button]:w-[299px] [&_button]:w-[258px]'
        sectionTitleClassName='w-full'
      />
      <ServiceTipsSectionSection
        {...serviceTipsSectionContent}
        className={`[&_article]:text-center [&_article>div]:self-center`}
        sectionTitleClassName='w-full w-[90%]'
      />
      <ServiceTipsSectionSection
        isBgDark
        {...typesOfGolfClubsSectionContent}
        className={`[&_article]:text-center [&_article>div]:self-center [&>div>div:nth-of-type(2)]:md-mn:grid-cols-3`}
        sectionTitleClassName='md-mn:[&_p]:w-full [&_p]:w-[90%]'
      />
      <WhyWeSection
        {...whyChooseUsSectionContent}
        className='[&_article]:text-center [&_article>div]:self-center [&_article]:border-none [&_article]:bg-transparent'
        imgClassName='w-[130px] h-[130px]'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`lg-mn:[&_button]:w-[273px] [&_button]:w-[276px]`}
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default GolfClubStoragePage
